import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_PAYMENT_CLIENT_LOADING = 'GET_PAYMENT_CLIENT_LOADING';
export const GET_PAYMENT_CLIENT_SUCCESS = 'GET_PAYMENT_CLIENT_SUCCESS';
export const GET_PAYMENT_CLIENT_REJECT = 'GET_PAYMENT_CLIENT_REJECT';

//* ACTIONS ------------------------------------------------
export const getPaymentClientLoading = () => ({ type: GET_PAYMENT_CLIENT_LOADING });
export const getPaymentClientSuccess = (payload) => ({ type: GET_PAYMENT_CLIENT_SUCCESS, payload });
export const getPaymentClientReject = (payload) => ({ type: GET_PAYMENT_CLIENT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getPaymentClientRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params: { ...data, Export: false, IsAutomatic: false },
    }, getState);
    return request(`/Clients/web/GetAllClientsServices`, options);
};

